import classnames from "classnames";
import {
  getHours,
  getMinutes,
  setHours,
  setMinutes,
  setSeconds,
} from "date-fns";
import { map } from "lodash-es";
import React from "react";
import { FormattedMessage, FormattedTime } from "react-intl";

import { getValidRescheduleTimes } from "~/utils";

const TIMES = getValidRescheduleTimes();
export interface TimePickerProps {
  selectedDate: Date;
  setSelectedDate: (time: Date) => unknown;
}

export const TimePicker: React.FC<TimePickerProps> = ({
  selectedDate,
  setSelectedDate,
}) => {
  const setTimeInDate = (time: Date) => {
    let newDate = selectedDate;
    newDate = setHours(newDate, getHours(time));
    newDate = setMinutes(newDate, getMinutes(time));
    newDate = setSeconds(newDate, 0);
    setSelectedDate(newDate);
  };

  return (
    <div className="bg-dark pd-lg borderR-02">
      <p>
        <FormattedMessage defaultMessage="Pick a time interval" id="VHlbO1" />
      </p>
      <div className="grid-cols-4-3 text-start justify-start gap-md">
        {map(TIMES, (time: Date) => (
          <span
            key={time.toString()}
            className={classnames(
              {
                "btn-success":
                  getHours(time) === getHours(selectedDate) &&
                  getMinutes(time) === getMinutes(selectedDate),
              },
              "pd-sm border text-center pointer text-08"
            )}
            onClick={() => setTimeInDate(time)}
          >
            <FormattedTime value={time} />
          </span>
        ))}
      </div>
    </div>
  );
};
